export default [
  {
    path: 'jogadores/taxa-conversao',
    name: 'taxa-conversao',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Taxa de Conversão',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Jogadores', link: 'jogadores.group' },
        { name: 'Taxa de Conversão', },
      ]
    }
  },
]